/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { AwardedLaneListItemFragmentDoc } from './AwardedLaneListItemFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IAwardedLanesQueryVariables = Types.Exact<{
  after?: Types.Maybe<Types.Scalars['String']>
  before?: Types.Maybe<Types.Scalars['String']>
  first?: Types.Maybe<Types.Scalars['Int']>
  last?: Types.Maybe<Types.Scalars['Int']>
  pickupLocation?: Types.Maybe<Types.ILocationFilterInput>
  deliveryLocation?: Types.Maybe<Types.ILocationFilterInput>
  shipperRateId?: Types.Maybe<Types.Scalars['ID']>
  carrierSalesRepIds?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  sourceStatuses?: Types.Maybe<
    Array<Types.IShipperRateSourceStatusEnum> | Types.IShipperRateSourceStatusEnum
  >
  shipperApplicationIds?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  carrierApplicationIds?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  dropTypes?: Types.Maybe<
    Array<Types.IFacilityScheduleRulesUnloadTypes> | Types.IFacilityScheduleRulesUnloadTypes
  >
  equipmentIds?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  sortBy?: Types.Maybe<Types.IShipperRatesSortByEnum>
  sortDirection?: Types.Maybe<Types.ISortOrderEnum>
  shouldSource?: Types.Maybe<Types.Scalars['Boolean']>
}>

export type IAwardedLanesQuery = { __typename?: 'Query' } & {
  shipperRates: { __typename?: 'ShipperRateConnection' } & Pick<
    Types.IShipperRateConnection,
    'totalCount'
  > & {
      edges?: Types.Maybe<
        Array<
          Types.Maybe<
            { __typename?: 'ShipperRateEdge' } & {
              node?: Types.Maybe<
                { __typename?: 'ShipperRate' } & Pick<
                  Types.IShipperRate,
                  | 'id'
                  | 'deliveryCity'
                  | 'deliveryStateCode'
                  | 'deliveryRegion'
                  | 'endDate'
                  | 'isDeliveryDropTrailer'
                  | 'isPickupDropTrailer'
                  | 'pickupCity'
                  | 'pickupStateCode'
                  | 'pickupRegion'
                  | 'sourcedCarrierRatesCount'
                  | 'sourceStatus'
                  | 'startDate'
                  | 'weeklyVolume'
                > & {
                    carrierSalesRep?: Types.Maybe<
                      { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
                    >
                    deliveryLocation?: Types.Maybe<
                      { __typename?: 'Location' } & Pick<
                        Types.ILocation,
                        'id' | 'city' | 'stateCode'
                      >
                    >
                    equipment?: Types.Maybe<
                      { __typename?: 'Equipment' } & Pick<
                        Types.IEquipment,
                        'id' | 'key' | 'name' | 'parentKey'
                      > & {
                          parent?: Types.Maybe<
                            { __typename?: 'Equipment' } & Pick<Types.IEquipment, 'id'>
                          >
                        }
                    >
                    pickupLocation?: Types.Maybe<
                      { __typename?: 'Location' } & Pick<
                        Types.ILocation,
                        'id' | 'city' | 'stateCode'
                      >
                    >
                    shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
                      Types.IShipperApplication,
                      'id' | 'name'
                    >
                  }
              >
            }
          >
        >
      >
      pageInfo: { __typename?: 'PageInfo' } & Pick<
        Types.IPageInfo,
        'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
      >
    }
}

export const AwardedLanesDocument = gql`
  query AwardedLanes(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $pickupLocation: LocationFilterInput
    $deliveryLocation: LocationFilterInput
    $shipperRateId: ID
    $carrierSalesRepIds: [ID!]
    $sourceStatuses: [ShipperRateSourceStatusEnum!]
    $shipperApplicationIds: [ID!]
    $carrierApplicationIds: [ID!]
    $dropTypes: [FacilityScheduleRulesUnloadTypes!]
    $equipmentIds: [ID!]
    $sortBy: ShipperRatesSortByEnum
    $sortDirection: SortOrderEnum
    $shouldSource: Boolean = true
  ) {
    shipperRates(
      after: $after
      before: $before
      first: $first
      last: $last
      pickupLocation: $pickupLocation
      deliveryLocation: $deliveryLocation
      shipperRateId: $shipperRateId
      carrierSalesRepIds: $carrierSalesRepIds
      sourceStatuses: $sourceStatuses
      shipperApplicationIds: $shipperApplicationIds
      carrierApplicationIds: $carrierApplicationIds
      dropTypes: $dropTypes
      equipmentIds: $equipmentIds
      sortBy: $sortBy
      sortDirection: $sortDirection
      shouldSource: $shouldSource
    ) {
      edges {
        node {
          ...AwardedLaneListItem
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
  ${AwardedLaneListItemFragmentDoc}
`

/**
 * __useAwardedLanesQuery__
 *
 * To run a query within a React component, call `useAwardedLanesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwardedLanesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardedLanesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      pickupLocation: // value for 'pickupLocation'
 *      deliveryLocation: // value for 'deliveryLocation'
 *      shipperRateId: // value for 'shipperRateId'
 *      carrierSalesRepIds: // value for 'carrierSalesRepIds'
 *      sourceStatuses: // value for 'sourceStatuses'
 *      shipperApplicationIds: // value for 'shipperApplicationIds'
 *      carrierApplicationIds: // value for 'carrierApplicationIds'
 *      dropTypes: // value for 'dropTypes'
 *      equipmentIds: // value for 'equipmentIds'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      shouldSource: // value for 'shouldSource'
 *   },
 * });
 */
export function useAwardedLanesQuery(
  baseOptions?: Apollo.QueryHookOptions<IAwardedLanesQuery, IAwardedLanesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAwardedLanesQuery, IAwardedLanesQueryVariables>(
    AwardedLanesDocument,
    options
  )
}
export function useAwardedLanesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAwardedLanesQuery, IAwardedLanesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAwardedLanesQuery, IAwardedLanesQueryVariables>(
    AwardedLanesDocument,
    options
  )
}
export type AwardedLanesQueryHookResult = ReturnType<typeof useAwardedLanesQuery>
export type AwardedLanesLazyQueryHookResult = ReturnType<typeof useAwardedLanesLazyQuery>
export type AwardedLanesQueryResult = Apollo.QueryResult<
  IAwardedLanesQuery,
  IAwardedLanesQueryVariables
>
